import { useLayoutEffect, useState } from "react";

export const TEXT_SCALES = [1, 1.25];
export const TEXT_SCALE_FRAME_GROW = 40;
export const TEXT_SCALE_FRAME_GROW_X = TEXT_SCALE_FRAME_GROW + 40;

const STORAGE_PREFIX = "vocabularium_text_scale:";
const listeners = new Set();

export function sanitizeTextScale(value) {
  const number = Number(value);
  if (!Number.isFinite(number) || number <= 1) return 1;
  return 1.25;
}

export function formatTextScaleLabel(scale) {
  if (Number(scale) > 1) return "100 %";
  return "75 %";
}

function storageKey(userId) {
  return `${STORAGE_PREFIX}${userId}`;
}

export function readTextScale(userId) {
  if (!userId || typeof localStorage === "undefined") return 1;
  try {
    const stored = localStorage.getItem(storageKey(userId));
    if (stored == null || stored === "") return 1.25;
    return sanitizeTextScale(stored);
  } catch {
    return 1.25;
  }
}

export function applyTextScale(scale) {
  if (typeof document === "undefined") return;
  document.documentElement.style.setProperty("--text-scale", String(scale));
  document.documentElement.style.setProperty(
    "--frame-grow",
    scale > 1 ? `${TEXT_SCALE_FRAME_GROW}px` : "0px"
  );
  document.documentElement.style.setProperty(
    "--frame-grow-x",
    scale > 1 ? `${TEXT_SCALE_FRAME_GROW_X}px` : "0px"
  );
}

export function writeTextScale(userId, value) {
  if (!userId) return 1;
  const scale = sanitizeTextScale(value);
  try {
    localStorage.setItem(storageKey(userId), String(scale));
  } catch {
    // Le réglage reste appliqué pour cette visite.
  }
  applyTextScale(scale);
  listeners.forEach((listener) => listener(scale));
  return scale;
}

export function useAccountTextScale(userId) {
  const [scale, setScale] = useState(() => readTextScale(userId));

  useLayoutEffect(() => {
    const next = readTextScale(userId);
    setScale(next);
    applyTextScale(next);
    const onChange = (value) => setScale(value);
    listeners.add(onChange);
    return () => listeners.delete(onChange);
  }, [userId]);

  return [scale, (value) => writeTextScale(userId, value)];
}
